export const parseDataToDDMMYYYY = (data: string): string => {
  const splittedData = data.split("/");

  //return [splittedData[1], splittedData[0], splittedData[2]].join("/");
  return [splittedData[0], splittedData[1], splittedData[2]].join("/");
};
